<template>
<div class="form-group">
    <input
        :value="value"
        :type="type"
        :id="uuid"
        :placeholder="placeholder"
        class="form-control"
        :class="{
            'is-invalid': error,
            'form-control--filled': value
        }"
        @input="$emit('input', $event.target.value)"
        v-bind="ariaLabel ? { 'aria-label': ariaLabel } : {}"
    />
    <label
        v-if="label"
        :for="uuid"
    >
        <slot>Field: {{ uuid }}</slot>
    </label>
    <slot name="description"></slot>
    <slot
        v-if="error"
        name="error"
    >
        <div v-if="!customInvalid" class="invalid-feedback">
            Dieses Feld ist ein Pflichtfeld.
        </div>
        <div v-if="customInvalid" class="invalid-feedback">
            {{customInvalidMessage}}
        </div>
    </slot>
</div>

</template>

<script>
import uuid from 'uuid/v1'

export default {
    name: 'InputCustom',

    props: {
        ariaLabel: {
            type: String,
            default: null
        },

        type: {
            type: String,
            default: 'text'
        },

        label: {
            type: Boolean,
            default: true
        },
        placeholder: {
            type: String,
            default: ''
        },

        error: {
            type: Boolean,
            default: false
        },

        customInvalid: {
            type: Boolean,
            default: false
        },

        customInvalidMessage: {
            type: String,
            default: ''
        },

        value: null
    },

    data () {
        return {
            uuid: uuid()
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/elements/InputCustom.vue